
<template>
  <html>
    <head>
      
    </head>
    <body>
  <navbar></navbar>
  
      <div class=" bg-white">
      <div class="title-page-l">
    <img
          class="img-profile"
   src="https://library.kissclipart.com/20180918/zee/kissclipart-10-starbucks-gift-card-clipart-starbucks-15-gift-89984927cfbba34f.png"
        />
              </div>
        <div class="Detail">
        <p class="bo">แลกรับ บัตรสตาร์บัค starbucks card (e-coupon) มูลค่า 100 บาท</p>
         <div class="Detail-b">
        <p style="width: 40px;height: 40px;">ชื่อ</p>
        <p style="width:120px;height:50px;margin-top: 5px;"> เบอร์โทรศัพท์</p>
        <div class="Detail-bs">
        <p style="width: 100px;height: 40px; color: #7F8285;">พรชนก งามสม</p>
        <p style="width:120px;height:50px;margin-top: 5px;  color: #7F8285;">081-234-5678</p>
        </div>
      </div>
      
      </div>
     

      </div>
   

      <div class="row bt">
        <butto  type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-30">ยืนยัน</butto>
        <a href="ShopView02" type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-3">ยกเลิก</a>
      </div>
    </body>
  </html>

  
</template>
<script>
import Navbar from "./navbar"
export default {
name:"", 
components:{
    "navbar": Navbar
},
data() {
return {
}
 },
mounted(){
},
}
</script>
<style scoped>
@import "./Css/style.css";
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');

html, body {
  font-family: 'Roboto', sans-serif;
}

#app {
  font-family: 'Roboto', sans-serif;
}
.bg-white[data-v-fa9ae40a] {
background: #7bc79a;
    border-radius: 10px;

    width: 90%;
    position: relative;
    overflow: visible;
    top: 12px;
    margin-right: auto;
    margin-left: auto;
}
.row[data-v-fa9ae40a] {
    margin-right: 26px !important;
    margin-left: 25px !important;
}
.title-page-l {
  width: 100%;
  top: 90px;
  position: absolute;
  overflow: visible;
  text-align: left;

  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;

  letter-spacing: 2px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;

}
.Detail {
  display: table;
  top:320px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  width: 85px;
  left: 20px;
  height: 31px;
}
.Detail-b {
  display: table;
  top:79px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 20px;
}
.Detail-bs{
  display: table;
  top:0px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 150px;
}
.Detail p {
  color: #030000;
width: 250px;
    margin-bottom: 5px;
    height: 70px;

  padding: 0;
    font-style: normal;
margin-top: 16px;
}
.bg-white {
  background: #7bc79a;
  border-radius: 10px;
  height: 550px;
  width: 340px;
  position: relative;
  overflow: visible;
  top: 12px;
}
.img-profile {
 display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  background: white;
}
.name-profile {

  color: #231f20;
  padding: 15px 0px 0px 15px;
}

h1 {
  font-size: 20px;
  margin-top: 30px;
}
p {
  font-size: 16px;
  color: #7f8285;


}
.mt-30 {
  margin-top: 110px;
  text-align: center;
}
.mt-3 {
  margin-top: 126px;
  text-align: center;
  background:rgb(129, 129, 129);
}
.bt {
 top: -90px;
  border-radius: 10px;
  position: relative;
  overflow: visible;

}
</style>

